import { WillingToEnum } from '../types';
import { useExtraWorkText } from './useExtraWorkText';

export const useExtraWorkOption = () => {
  const extraWorkText = useExtraWorkText();

  return {
    value: WillingToEnum.extrasWork,
    label: extraWorkText,
  };
};
